export const errorHandlerVoid = (error: any) => {
  console.log(error)
}
